import { toast } from "sonner";

export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10 MB
const IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
const DOC_TYPES = [...IMAGE_TYPES, "application/pdf"];
const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "webp"];
const DOC_EXTS = [...IMAGE_EXTS, "pdf"];

// kind: "image" (görsel) | "document" (görsel + pdf)
export function validateUpload(file, kind = "document") {
  const ext = file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "";
  const allowedTypes = kind === "image" ? IMAGE_TYPES : DOC_TYPES;
  const allowedExts = kind === "image" ? IMAGE_EXTS : DOC_EXTS;
  const okType = allowedTypes.includes(file.type) || allowedExts.includes(ext);
  if (!okType) {
    const label = kind === "image" ? "görsel (JPG, PNG, GIF, WEBP)" : "görsel veya PDF";
    toast.error(`Geçersiz dosya türü. Yalnızca ${label} yükleyebilirsiniz.`);
    return false;
  }
  if (file.size > MAX_UPLOAD_SIZE) {
    toast.error(`Dosya çok büyük. En fazla ${MAX_UPLOAD_SIZE / (1024 * 1024)} MB yükleyebilirsiniz.`);
    return false;
  }
  if (file.size === 0) {
    toast.error("Boş dosya yüklenemez.");
    return false;
  }
  return true;
}
